import React, { useState, useEffect, useRef } from 'react'

const LazyYTEmbed = ({ embedUrl, width = '100%', height = '348', title = 'YouTube video' }) => {
  const [inView, setInView] = useState(false)
  const ref = useRef()

  useEffect(() => {
    const observer = new IntersectionObserver(
      ([entry]) => {
        if (entry.isIntersecting) {
          setInView(true)
          observer.disconnect()
        }
      },
      {
        rootMargin: '0px',
      }
    )

    if (ref.current) {
      observer.observe(ref.current)
    }

    return () => {
      if (ref.current) {
        observer.unobserve(ref.current)
      }
    }
  }, [])

  const autoplayUrl = embedUrl + (embedUrl.includes('?') ? '&' : '?') + 'autoplay=1&mute=1'

  return (
    <div ref={ref} style={{ width, height }}>
      {inView ? (
        <iframe
          style={{
            borderRadius: '22px',
            border: '5px solid rgb(255, 255, 255)',
          }}
          width="100%"
          height="348"
          src={autoplayUrl}
          title={title}
          frameBorder="0"
          referrerPolicy="strict-origin-when-cross-origin"
          allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
          allowFullScreen
        />
      ) : (
        <div
          style={{
            width: '100%',
            height: '100%',
            backgroundColor: 'black',
            borderRadius: '22px',
            border: '5px solid rgb(255, 255, 255)',
          }}
        />
      )}
    </div>
  )
}

export default LazyYTEmbed
